export function Box({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.1576 5.86508L9.38261 9.21008C9.15011 9.34508 8.85761 9.34508 8.61761 9.21008L2.84261 5.86508C2.43011 5.62508 2.32511 5.06258 2.64011 4.71008C2.85761 4.46258 3.10511 4.26008 3.36761 4.11758L7.43261 1.86758C8.30261 1.38008 9.71261 1.38008 10.5826 1.86758L14.6476 4.11758C14.9101 4.26008 15.1576 4.47008 15.3751 4.71008C15.6751 5.06258 15.5701 5.62508 15.1576 5.86508Z"
          fill="currentColor"
        />
        <path
          d="M8.57261 10.6051V15.7201C8.57261 16.2901 7.99511 16.6651 7.48511 16.4176C5.94011 15.6601 3.33761 14.2426 3.33761 14.2426C2.42261 13.7251 1.67261 12.4201 1.67261 11.3476V7.47758C1.67261 6.88508 2.29511 6.51008 2.80511 6.80258L8.19761 9.93008C8.42261 10.0726 8.57261 10.3276 8.57261 10.6051Z"
          fill="currentColor"
        />
        <path
          d="M9.42761 10.6051V15.7201C9.42761 16.2901 10.0051 16.6651 10.5151 16.4176C12.0601 15.6601 14.6626 14.2426 14.6626 14.2426C15.5776 13.7251 16.3276 12.4201 16.3276 11.3476V7.47758C16.3276 6.88508 15.7051 6.51008 15.1951 6.80258L9.80261 9.93008C9.57761 10.0726 9.42761 10.3276 9.42761 10.6051Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
